import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { EcaBreadcrumbService } from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { OurUserService } from '../../../users/services/user.service';
import { AlertsService } from '../../../alerts/services/alerts.service';
import { FileUpload } from "primeng/fileupload";
import { NgForm } from '@angular/forms';
import { IDocumentType } from '../../../message-models/document-type.interface';
import { IEntityDocumentSummary } from '../../../message-models/entity-document-summary';
import { EntityDocumentSummary } from '../../../message-models/entity-document-summary.class';
import { IDateTimeWithZone } from '../../../common/date-time-with-zone.interface';
import { consts } from '../../../common/modals/consts';
import { HelpConsts } from "../../../help/models/help-consts";
import { IUserInfo } from '../../../users/models/userInfo.interface';
import { Subscription } from 'rxjs';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { IBreadcrumb } from '../../../eca-breadcrumb/models/breadcrumb.interface';
import { CompanyDocumentService } from '../../../company/services/company-documents.service';
import { DocumentTypeService } from '../../../services/document-type.service';
import { DocumentEntityType } from '../../../message-models/document-entity-type.enum';
import { IDocumentSummaryInfo } from '../../../message-models/document-summary-info.interface';
import { SettingsProviderService } from '../../../common/settings-provider.service';
import { EcaConfirmProcessService } from '../../../shared/services/eca-confirm-process.service';
import { EcaConfirmInfoModalOptions } from '../../../shared/models/confirm-info-modal-options.class';


@Component({
  selector: 'operative-upload',
  templateUrl: './operative-upload.component.html',
  styleUrls: ['./operative-upload.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OperativeUploadComponent implements OnInit, OnDestroy {
  @Input() uploadButtonText = 'Upload';
  @Input() uploadButtonColour = 'success';
  @Input() uploadButtonIcon: string = null;
  @ViewChild('documentUploadForm', { static: true }) documentUploadForm: NgForm;
  @ViewChild('uploader', { static: true }) uploader: FileUpload;
  @Input() documentTypes: IDocumentType[];
  @Input() entityDocumentSummary: IEntityDocumentSummary;
  documentUploadRequest: FormData;
  @Output() documentUploadSave: EventEmitter<FormData> = new EventEmitter<FormData>();
  @Output() cancelClicked: EventEmitter<void> = new EventEmitter<void>();
  tempDocumentSummary: IEntityDocumentSummary;
  formIsValid = false;
  saveAttempted: boolean = false;
  showingHelp: boolean = false;
  helpText: string = HelpConsts.DocumentsEntryHelp.sections[0].body;
  loggedInUser: IUserInfo;
  private companyId: string = consts.emptyGuid;
  private loggedInUserSubscription: Subscription;
  companyDocumentSummaries: IDocumentSummaryInfo[] = [];
  loading: boolean = true;
  private settingsProviderService: SettingsProviderService;
  @Input() templateButtonText = 'Download Template';

  constructor(private ecaBreadcrumbService: EcaBreadcrumbService,
    private alertsService: AlertsService,
    private userService: OurUserService,
    private errorHandlingService: ErrorHandlingService,
    private documentTypeService: DocumentTypeService,
    private companyDocumentService: CompanyDocumentService,
    private confirmProcessService: EcaConfirmProcessService) { }

  ngOnInit(): void {
    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUserSubscription = this.userService.getLoggedInUserSubject().subscribe(user => {
        if (user) {
          this.updateUserAndReload(user);
          this.populateBreadcrumbs();
        }
      })
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
    this.initDocumentUploadForm();
  }

  initDocumentUploadForm() {
    this.documentUploadRequest = new FormData();
    this.tempDocumentSummary = new EntityDocumentSummary(this.entityDocumentSummary);
    this.loading = false;
  }

  ngOnDestroy() {
  }

  clicked(answer: boolean) {
    this.documentUploadRequest.append('DocumentId', this.tempDocumentSummary.documentId);
    this.documentUploadRequest.append('DocumentTypeId', "0381A32E-D4A3-4960-86ED-04B72A3CD843");
    this.documentUploadRequest.append('ExtraDescription', "Operative Upload");
    this.documentUploadRequest.append('OriginalFilename', this.tempDocumentSummary.originalFilename);
    this.uploadOperativeDocument(this.documentUploadRequest);
  }

  uploadOperativeDocument(uploadRequest: FormData) {
    this.loading = true;
    this.documentUploadRequest.append('CompanyId', this.companyId);
    this.companyDocumentService.createOrUpdateCompanyDocument(this.documentUploadRequest).subscribe(companyDocumentSummary => {
      this.loading = false;
      this.getCompanyDocumentSummaries(this.companyId);
      this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
      this.confirmProcessService.openConfirmProcessModal(`Your Operatives have succssfully been uploaded`, 'Operative Upload - Success',
        new EcaConfirmInfoModalOptions()).asObservable().subscribe(res2 => {
        });
    },
      error => {
        this.errorHandlingService.showErrorWarning(error.error).subscribe(userResponse => {
          this.loading = false;
          this.formIsValid = false;
        });
      });
  }

  private updateUserAndReload(user: IUserInfo) {
    this.loggedInUser = user;
    this.companyId = this.loggedInUser?.companyId;
  }

  private populateBreadcrumbs() {
    const operativeBreadCrumbs = new Array<IBreadcrumb>();
    operativeBreadCrumbs.push({
      label: this.loggedInUser?.companyName?.toString() + ' - ' + 'Enterprise Documents',
      iconName: 'books',
    } as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
  }

  getCompanyDocumentSummaries(companyId: string, includeExpired: boolean = false) {
    this.companyDocumentService.getAllDocumentSummariesByEntityType(companyId, DocumentEntityType.company, includeExpired).subscribe(companyDocuments => {
      this.companyDocumentSummaries = companyDocuments;
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  fileUploaded(file: File) {
    if (file) {
      this.documentUploadRequest.append('FormFile', file, file.name);
      this.formIsValid = true;
    } else {
      this.formIsValid = false;
    }
  }

  removeFile(remove: boolean) {
    if (remove) {
      this.documentUploadRequest.delete('FormFile');
      this.formIsValid = false;
    }
  }

  templateButtonUrl() {
    this.settingsProviderService = new SettingsProviderService('');
    var url = this.settingsProviderService.baseUrl + 'Templates/Operative Details Upload.xlsx';
    window.open(url);
  }
}
